
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SvgIconComponent } from "@ngneat/svg-icon";
import { NgxPopperjsModule, NgxPopperjsPlacements, NgxPopperjsTriggers } from "ngx-popperjs";

@Component({
    selector: 'nts-label-box',
    templateUrl: './label-box.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./label-box.component.scss'],
    imports: [
    NgxPopperjsModule,
    SvgIconComponent
]
})
export class LabelBoxComponent {
    @Input() isLocked = false;
    @Input() isEnabled = true;
    @Input() isRequired = false;
    @Input() labelId?: string;
    @Input() label = "";
    @Input() title = "";
    @Input() showTitleTooltip = true;

    ngxPopperjsTriggers = NgxPopperjsTriggers;
    ngxPopperjsPlacements = NgxPopperjsPlacements;
}